import { combineReducers } from "redux";
import { RootState } from "../types";
import feedback from "../../../Feedback/reducer";
import initialization from "./initialization";
import user from "./user";
import country from "./country";

export default combineReducers<RootState>({
    feedback,
    initialization,
    user,
    country
});
